// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3QS59","footer":"ModalError_footer__3q18h"};